import { useMutation, useQueryClient } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import type { User } from '@/models/user';
import { accept_api_account_terms_path } from '@/utils/routes';

export const useAcceptTerms = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () =>
      await falconClient.post(accept_api_account_terms_path(), {}),
    onSuccess: () => {
      // Patch instead of invalidating: an invalidate would refetch the
      // still-stale terms_accepted before the async Sidekiq sync lands.
      queryClient.setQueryData<{ data: User }>(
        [clientKeys.useUser],
        (old) =>
          old && {
            ...old,
            data: { ...old.data, terms_accepted: true },
          }
      );
    },
  });
};
